import config from 'config';
import PropTypes from 'prop-types';
import { MotReminder, ServiceReminder, SubscriberBarReminder } from '$components/composite/ReminderWidgets';

export default function BlogReminder({ data }) {
  const { reminderType } = data;

  switch (reminderType) {
    case 'service':
      return (
        <ServiceReminder
          apiKey={config.get('public.fixter_api.gateway_key')}
          consumerApiUrl={config.get('public.fixter_api.url')}
          source="blog"
        />
      );
    case 'subscribe':
      return (
        <SubscriberBarReminder
          apiKey={config.get('public.fixter_api.gateway_key')}
          consumerApiUrl={config.get('public.fixter_api.url')}
          source="blog"
        />
      );
    default:
      return (
        <MotReminder
          apiKey={config.get('public.fixter_api.gateway_key')}
          consumerApiUrl={config.get('public.fixter_api.url')}
          source="blog"
        />
      );
  }
}

BlogReminder.propTypes = {
  data: PropTypes.any,
};

BlogReminder.defaultProps = {
  data: {},
};
